import type React from "react";
import type { DeliverablesData } from "../../types/portal";

interface DeliverablesViewProps {
  deliverables: DeliverablesData | undefined;
  fallbackSummary?: string;
  fallbackChecklist?: string[];
  pendingMessage?: string;
  showPending?: boolean;
}

const DeliverablesView: React.FC<DeliverablesViewProps> = ({
  deliverables,
  fallbackSummary,
  fallbackChecklist,
  pendingMessage = "Deliverables are pending. Your trainer will add a summary and checklist soon.",
  showPending = false,
}) => {
  const summary = deliverables?.summary || fallbackSummary;
  const checklist =
    deliverables?.checklist_items && deliverables.checklist_items.length > 0
      ? deliverables.checklist_items
      : fallbackChecklist;

  if (!deliverables && !fallbackSummary && (!fallbackChecklist || fallbackChecklist.length === 0)) {
    if (showPending) {
      return (
        <div className="mb-6">
          <p className="text-[0.95rem] text-muted-foreground italic text-center p-5 bg-muted rounded-lg border border-dashed border-border">
            {pendingMessage}
          </p>
        </div>
      );
    }
    return null;
  }

  return (
    <>
      {summary && (
        <div className="mb-6">
          <h3 className="text-[1.1rem] font-semibold text-foreground mb-3">Session Summary</h3>
          <p className="text-[0.95rem] text-muted-foreground leading-relaxed max-h-[200px] overflow-y-auto p-2.5 bg-muted rounded-lg border border-border">
            {summary}
          </p>
        </div>
      )}
      {checklist && checklist.length > 0 && (
        <div className="mb-6">
          <h3 className="text-[1.1rem] font-semibold text-foreground mb-3">Training Checklist</h3>
          <div className="flex flex-col gap-2.5 text-left">
            {checklist.map((item, index) => (
              <div key={index} className="flex items-start gap-2.5 text-left">
                <span className="text-[0.95rem] text-primary font-semibold leading-relaxed min-w-[24px]">
                  {index + 1}.
                </span>
                <span className="text-[0.95rem] text-muted-foreground leading-relaxed flex-1 text-left">
                  {item}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default DeliverablesView;
